import { Button, Flex } from "@chakra-ui/react";
import TableList from "components/TableList";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import constant from "constant";
import { api } from "services/api";
import { toaster } from "components/ui/toaster";
import utils from "utils";
import SearchInput from "components/SearchInput";
import PaginationComp from "components/PaginationComp";
import { Header } from "components/Header";
import DeleteConfim from "components/DeleteConfim";
import InputComp from "components/InputComp";
import { GoSync } from "react-icons/go";
import ButtonComp from "components/Button";
import storage from "utils/storage";
import CardAmount from "components/CardAmount";

const headers = [
  // "Actions",
  "Agreement",
  "State",
  "Created",
  "Retailer",
  "Details",
  "Products",
  "Cover",
  // "Accepted",
];

// const items = [
// {
//   id: 1,
//   actions: ["print", "del"],
//   Agreements: "Agreements",
//   State: "State",
//   Created: "Created",
//   Retailer: "Retailer",
//   Details: "Details",
//   Products: "Products",
//   Cover: "Cover",
//   Accepted: "Accepted",
// },
// ];

function Agreements() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const [dealers, setDealers] = useState();
  const [filerLast, setFilerLast] = useState(constant.filterLast);
  const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [summaryData, setSummaryData] = useState({});

  const navigate = useNavigate();

  const onPrint = async () => {
    setIsLoading(true);
    const res = await api.getAgreementPrint({
      policyid: selectedItem?.item?.data?.policyid,
    });
    setIsLoading(false);
    console.log("getAgreementPrint", res);
    if (res?.status === 200) {
      if (res?.data?.file?.type === "pdf" && res?.data?.file?.stream) {
        // console.log(res?.data?.file?.stream || "");
        let pdf = {
          file: `data:application/pdf;base64,${res?.data?.file?.stream}`,
          file_name: res?.data?.file?.name || "AU_Warranties_Agreement",
        };

        const pdfLink = `${pdf.file}`;
        const anchorElement = document.createElement("a");
        const fileName = `${pdf.file_name}.pdf`;
        anchorElement.href = pdfLink;
        anchorElement.download = fileName;
        anchorElement.click();
      }
      return;
    }
    toaster.create({
      title: res?.data?.message || res?.message,
      type: "error",
    });
    return;
  };

  const onClickNew = () => {
    navigate("/agreementsadd", {
      state: {
        action: "agreement-add",
        data: { branchid: utils.getDealerid(dealers) },
      },
    });
  };

  const onEmailSent = async () => {
    setIsLoading(true);
    const res = await api.sendemailAgreement({
      policyid: selectedItem?.item?.data?.policyid,
      policynumber: selectedItem?.item?.data?.policynumber,
      companyname: selectedItem?.item?.data?.company,
      to: selectedItem?.item?.data?.email,
    });
    setIsLoading(false);
    console.log("sentEmail", res);
    if (res?.status === 200) {
      onRefresh();
    }

    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });
  };

  const onDelete = async () => {
    setIsLoading(true);
    const res = await api.deleteAgreement({
      policyid: selectedItem?.item?.data?.policyid,
      policynumber: selectedItem?.item?.data?.policynumber,
    });
    setIsLoading(false);
    console.log("deleteAgreement", res);
    if (res?.status === 200) {
      onRefresh();
    }

    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });
  };

  const getList = async (data) => {
    const appcatch = storage.get("appcatch") || {};
    console.log("getList appcatch", appcatch);
    setSelectedItem();
    // if (data?.dealerid === undefined || data?.dealerid === null) {
    //   setList([]);
    //   return;
    // }
    const stext = data.searchTxt === undefined ? searchTxt : data.searchTxt;

    // if (stext) {
    //   setSearchLoading(true);
    // }

    const pl = {
      dealerid: appcatch?.agreements_dealerid, //data.dealerid ?? utils.getDealerid(dealers),
      searchTxt: stext,
      limitId: appcatch?.agreements_limitkey, //data.limitId || utils.getLimitId(filerLast),
      page: data.page || activePage,
    };

    if (!pl.limitId) {
      console.log("err getList limitId null");
      setList([]);
      return;
    }

    if (!pl.dealerid) {
      console.log("err getList dealerid null");
      setList([]);
      return;
    }

    setIsLoading(true);
    return api.getAgreements(pl).then((res) => {
      setIsLoading(false);
      // if (stext) {
      //   setSearchLoading(true);
      // }

      console.log(res?.data);
      if (res?.status === 200) {
        if (data?.page) {
          setActivePage(data.page);
        }
        if (res?.data?.list && res.data.list[0]) {
          setList(
            res.data.list.map((a, index) => ({
              id: `agr-itm-${index}`,
              // key: `agr-itm-${index}`,
              // actions: ["print", "del"],
              Agreements: a?.policynumber || "",
              State: a?.statename || "",
              Created: a?.datepolicy
                ? utils.formatToDDMMYYYY(a?.datepolicy)
                : "",
              Retailer: a?.branchname || "",
              Details: `${a.carmake || ""} ${a.carmodel || ""} ${
                a.carcolour || ""
              }`,
              Products: `${a?.durationvalue || ""} ${a?.durationtype || ""}`,
              Cover: a?.covertype,
              // Accepted: a?.acceptedvalue || "",
              data: a,
              // Date: utils.dateStrToStr(a.transdate),
              // Description: a.description,
              // Admin: utils.formatCurrency(a.admin),
              // Tax: utils.formatCurrency(a.totaltax),
              // "Non-Refundable Agreements": utils.formatCurrency(a.norefund),
              // In: "-",
              // Out: "-",
              // Balance: "-",
            }))
          );
        } else {
          setList([]);
        }

        if (res?.data?.summary) {
          let {
            paid_total_gross,
            paid_total_policies,
            invoiced_total,
            invoiced_total_policies,
            not_invoiced,
            total_policies,
          } = res?.data?.summary;

          paid_total_gross = utils.formatNumF2(paid_total_gross);
          paid_total_policies = utils.formatNum(paid_total_policies);

          invoiced_total = utils.formatNumF2(invoiced_total);
          invoiced_total_policies = utils.formatNum(invoiced_total_policies);

          not_invoiced = utils.formatNum(not_invoiced);
          total_policies = utils.formatNum(total_policies);

          setSummaryData({
            paid_total_gross,
            paid_total_policies,
            invoiced_total,
            invoiced_total_policies,
            not_invoiced,
            total_policies,
          });
        }
      } else {
        setList([]);
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
      // if (data.searchTxt !== undefined) {
      //   setSearchLoading(false);
      // }
    });
  };

  const onchangeFlLast = (data) => {
    console.log("onchangeFlLast", data.list);

    if (data?.item?.key) {
      const appcatch = storage.get("appcatch") || {};
      appcatch.agreements_limitkey = data?.item?.key;
      storage.set("appcatch", appcatch);

      setFilerLast([...data.list]);
      getList({
        page: 1,
        // limitId: data.item?.key,
        // dealerid: utils.getDealerid(dealers),
      });
    }
  };

  const onDealersChange = (data) => {
    console.log("onDealersChange data", data);

    const appcatch = storage.get("appcatch") || {};
    appcatch.agreements_dealerid = data?.item?.data?.dealerid;
    storage.set("appcatch", appcatch);

    setDealers(data?.list ? [...data.list] : []);
    // if (data?.item?.data?.dealerid || data?.item?.data?.dealerid === 0) {

    getList({
      // dealerid: data?.item?.data?.dealerid,
      page: 1,
    });
    // }
  };

  const onChangeSearchTxt = (v) => {
    setSearchTxt(v);
    getList({
      searchTxt: v,
      page: 1,
      // limitId: utils.getLimitId(filerLast),
      // dealerid: utils.getDealerid(dealers),
    });
    // setSearchLoading(true);
  };

  const onSelectItm = (data) => {
    setSelectedItem(data);
  };

  const onChangePage = (data) => {
    if (data.page === activePage) {
      return;
    }
    getList({
      page: data.page,
      // limitId: utils.getLimitId(filerLast),
      searchTxt: searchTxt,
      // dealerid: utils.getDealerid(dealers),
    });
  };

  const onClickOpen = () => {
    navigate("/agreementsadd", {
      state: { action: "agreement-edit", data: selectedItem?.item?.data },
    });
  };

  // const getDealers = async () => {
  //   setIsLoading(true);
  //   return api.getDealers().then((res) => {
  //     console.log("getDealers =", res);
  //     setIsLoading(false);
  //     if (res?.status === 200) {
  //       if (res?.data && res?.data[0]) {
  //         let arr = res.data.map((a, index) => ({
  //           key: `dealer-${index}`,
  //           value: `${a?.companyname}-${index}`,
  //           label: a?.companyname,
  //           data: { dealerid: a?.dealerid },
  //         }));

  //         if (arr && arr[0].key) {
  //           if (arr.length > 1) {
  //             arr = [
  //               {
  //                 key: "dealer-all",
  //                 value: "all",
  //                 label: "All",
  //                 data: { dealerid: 0 },
  //               },
  //               ...arr,
  //             ];
  //           }
  //           arr[0].selected = true;
  //           onDealersChange({
  //             index: 0,
  //             list: arr,
  //             item: arr[0],
  //           });
  //           // setDealers(arr);
  //         } else {
  //           // setDealers(arr);
  //           onDealersChange({
  //             list: [],
  //           });
  //         }
  //         // getList({ dealerid: arr[0]?.data.dealerid });
  //       }
  //     } else {
  //       onDealersChange({
  //         list: [],
  //       });

  //       toaster.create({
  //         title: res?.message,
  //         type: "error",
  //       });
  //     }
  //   });
  // };

  const onRefresh = () => {
    getList({
      // dealerid: utils.getDealerid(dealers),
    });
  };

  useEffect(() => {
    const cb = async () => {
      const appcatch = storage.get("appcatch") || {};

      // const filLast = [...constant.filterLast];
      // filLast[0].selected = true;
      // setFilerLast(filLast);

      await utils.getDealers({
        setIsLoading,
        action: "useState",
        onDealersChange,
        defaultVal: appcatch?.agreements_dealerid,
      });

      utils.getLimitDD({
        onChangeFlLast: onchangeFlLast,
        defaultVal: appcatch?.agreements_limitkey,
      });
    };
    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Agreements"} isLoading={isLoading} />
      <Flex
        width={"100%"}
        flexFlow={"wrap"}
        gap={"1rem"}
        alignItems={"center"}
        mb={"1rem"}
      >
        <DeleteConfim
          onDelete={onDelete}
          TrigarComp={
            <ButtonComp
              label={"Delete"}
              keyname="delete"
              disabled={!selectedItem || isLoading}
              variant="outline"
            />
          }
        />
        <InputComp
          type={"dropdown"}
          items={filerLast}
          onChange={onchangeFlLast}
          keyname={"last-filter"}
          placeholder={"Select Limit"}
        />

        <InputComp
          type={"dropdown"}
          // <DropDown
          // w={"15rem"}
          items={dealers}
          onChange={onDealersChange}
          // placeholder={'Select Dealer'}
          placeholder={"Select Account"}
        />
        <Button
          onClick={onEmailSent}
          disabled={!selectedItem || isLoading}
          variant="outline"
        >
          Email
        </Button>
        <Button onClick={onRefresh} variant="outline" disabled={isLoading}>
          <GoSync />
        </Button>
        <Flex flex={1} />
        {/* <Flex flexFlow={"wrap"} alignItems={'center'} gap={'2rem'}> */}
        {/* <Field.Label textStyle={fs}>Town</Field.Label> */}
        <Button onClick={onClickNew} variant="outline">
          New
        </Button>
        <Button
          disabled={!selectedItem}
          onClick={onClickOpen}
          variant="outline"
        >
          Open
        </Button>
        <Button
          disabled={!selectedItem || isLoading}
          onClick={onPrint}
          variant="outline"
        >
          Print
        </Button>
        <SearchInput onChange={onChangeSearchTxt} />
      </Flex>
      {/* <Flex justifyContent="space-between" gap={"3"}> */}
      {/* </Flex> */}

      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        selectedItem={selectedItem}
      />

      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
        limit={utils.getLimitId(filerLast)}
      />

      <Flex mt={"1rem"} flexFlow={"wrap"} gap={"1rem"} overflow={"scroll"}>
        <CardAmount
          type={"simple"}
          color={"fontdark"}
          data={{
            label1: "Total: " + (summaryData?.total_policies || 0),
          }}
        />

        <CardAmount
          type={"simple"}
          color={"primary"}
          data={{
            label1: "Not Invoiced: " + (summaryData?.not_invoiced || 0),
          }}
        />

        <CardAmount
          type={"simple"}
          color={"orange"}
          data={{
            label1: "Pending: " + (summaryData?.invoiced_total_policies || 0),
            label2: utils.formatCurrency(summaryData?.invoiced_total),
          }}
        />

        <CardAmount
          type={"simple"}
          color={"green2"}
          data={{
            label1: "Paid: " + (summaryData?.paid_total_policies || 0),
            label2: utils.formatCurrency(summaryData?.paid_total_gross),
          }}
        />
      </Flex>
    </Flex>
  );
}

export default Agreements;
